import Plugin from '../plugin';
import UserSettings from '../../utility/user-settings';
import HyphenopolyUtility from '../../utility/hyphenopoly-utility';
import GeneralUtility from '../../utility/general-utility';
import ApiAdjacentAction from '../lawyer-api/adjacent-action';
import {AdjacentResult} from '../../../types/adjacent-result';

/**
 * Action for showing adjacent items.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class AdjacentAction extends ApiAdjacentAction {
  constructor(plugin: Plugin, container: HTMLElement) {
    super(plugin, container, 'news/adjacent/' + GeneralUtility.pageUid);
    this.update(UserSettings.getInstance().getPluginSettings(plugin.name));
  }


  protected initializeResult(result: AdjacentResult, settings: any) {
    super.initializeResult(result, settings);

    // Render handlebar template
    if (result.next || result.previous) {
      const template = require('../../templates/adjacent.handlebars');
      this.resultContainer.innerHTML += template({
        'next': result.next,
        'previous': result.previous
      });

      HyphenopolyUtility.hyphenate(this.resultContainer);
    }

    this.markReady();
  }
}
